import React from 'react';

// Components
import { WpText } from 'Wpds/components/text';
import TeamMemberWrapper from './TeamMemberWrapper';
import TeamMemberWithoutBAWrapper from './TeamMemberWithoutBAWrapper';

// Hooks
import { useFetchBulkBAData } from 'Shared/utils/hooks/use-fetch-bulk-ba-data';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';
import { useSmac } from 'Shared/utils/hooks/use-smac';

// Styles
import './WorkspaceSideRailTeam.scss';

const WorkspaceSideRailTeam: React.FC = () => {
  const { users } = useWorkspace();
  const { usersWithBA, usersWithPendingBA, usersWithoutBA, isLoading } = useFetchBulkBAData(users);
  const { hasDesignAccess } = useSmac();

  const baseClassName = 'WorkspaceSideRailTeam';

  if (isLoading) {
    return (
      <div className={`${baseClassName}__loading`}>
        <WpText>Loading...</WpText>
      </div>
    );
  }

  return (
    <div className={baseClassName}>
      {hasDesignAccess ? (
        <WpText noMargin>View your team members&apos; strengths and strongest team contributions.</WpText>
      ) : (
        <WpText noMargin>View your team members&apos; strengths, as well as their full behavioral details.</WpText>
      )}

      {usersWithBA.length > 0 && (
        <div className={`${baseClassName}__ba-section`}>
          {usersWithBA.map(user => (
            <TeamMemberWrapper key={user.id} user={user} />
          ))}
        </div>
      )}

      {usersWithoutBA.length > 0 && (
        <div className={`${baseClassName}__ba-section`}>
          <WpText bold>Invite team members to complete the Behavioral Assessment (BA)</WpText>
          <WpText>Discover this person&apos;s behavioral strengths and see how they impact your team dynamics.</WpText>
          {usersWithoutBA.map(user => (
            <TeamMemberWithoutBAWrapper
              key={user.id}
              user={user}
              buttonText="Send"
              buttonIcon="paper-plane"
              isPending={false}
            />
          ))}
        </div>
      )}

      {usersWithPendingBA.length > 0 && (
        <div className={`${baseClassName}__ba-section`}>
          <WpText bold>Pending Behavioral Assessments</WpText>
          {usersWithPendingBA.map(user => (
            <TeamMemberWithoutBAWrapper
              key={user.id}
              user={user}
              buttonText="Resend"
              buttonIcon="paper-plane"
              isPending={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default WorkspaceSideRailTeam;
